import { slice } from './slice';
export const companiesReducer = slice.reducer;
export * from './actions';
export * from './store';
